export enum EvaluationSteps {
  GOAL = 0,
  LOCATION = 1,
  PROPERTY_DETAILS = 2,
  PROPERTY_PRICE = 3,
  USER_ESTIMATED_PRICE = 4,
  DATA_ANALYSIS = 5,
}

export enum EstimationSteps {
  GOAL = 0,
  LOCATION = 1,
  PROPERTY_DETAILS = 2,
  DATA_ANALYSIS = 5,
}
